import React, { PureComponent } from 'react';
import gql from 'graphql-tag';
import { Mutation } from 'react-apollo';

const GET_CDS_SEARCH_URL = gql`
  mutation GetCdsSearchUrl($input: GetCdsSearchUrlInput!) {
    getCdsSearchUrl(input: $input)
  }
`;

export default Comp =>
  class WithGetCdsSearchUrl extends PureComponent {
    render() {
      return (
        <Mutation mutation={GET_CDS_SEARCH_URL} onError={() => undefined}>
          {(getCdsSearchUrl, { data, isLoading, error }) => (
            <Comp
              {...this.props}
              getCdsSearchUrlData={data}
              getCdsSearchUrlError={error}
              isLoadingGetCdsSearchUrl={isLoading}
              onGetCdsSearchUrl={getCdsSearchUrl}
            />
          )}
        </Mutation>
      );
    }
  };
